import { FormTextInputPrintEditor } from '../text-input/FormTextInputPrintEditor'

export const FormDatePickerPrintEditor = (props) => {
  return <FormTextInputPrintEditor {...props} />
}
